(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["av-cookie-preferences"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest('.footer a[data-av-cookie-preferences]');
    if (!link) return;

    const banner = window.privacyBanner;
    if (typeof banner?.showPreferences !== 'function') return;

    event.preventDefault();
    const openPrivacyPolicy = () => window.location.assign(link.href);

    try {
      Promise.resolve(banner.showPreferences()).catch(openPrivacyPolicy);
    } catch {
      openPrivacyPolicy();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('header-drawer details').forEach((detailsElement) => {
    detailsElement.addEventListener('toggle', () => {
      if (!detailsElement.open) return;
      const submenu = detailsElement.querySelector(':scope > .menu-drawer__submenu .menu-drawer__inner-submenu');
      if (submenu) submenu.scrollTop = 0;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
